import { gsap } from 'gsap'

export default {
    methods: {
        createAccordions: function() {
            const accordions = document.querySelectorAll('[data-accordion-toggle]')
            Array.from(accordions).forEach((accordion) => {
                accordion.addEventListener('click', function () {
                    const elParent = this.closest('[data-accordion]')
                    const elMain = elParent.querySelector('[data-accordion-main]')
                    const elButton = accordion.querySelector('button')

                    if (elParent.getAttribute('data-open') === 'true') {
                        elParent.setAttribute('data-open', 'false')
                        elButton.setAttribute('aria-expanded', 'false')
                        elMain.setAttribute('aria-hidden', 'true')
                        elMain.setAttribute('inert', '')
                        return
                    }

                    elParent.setAttribute('data-open', 'true')
                    elButton.setAttribute('aria-expanded', 'true')
                    elMain.setAttribute('aria-hidden', 'false')
                    elMain.removeAttribute('inert')
                })

                // Animated arrow svg
                accordion.addEventListener('mouseenter', function () {
                    const direction = this.closest('[data-accordion]').getAttribute('data-open') === 'true' ? -1 : 1

                    const tl = gsap.timeline({
                        defaults: {
                            duration: 0.2,
                            ease: 'power2.out',
                            clearProps: 'all',
                        },
                    })
                    tl.to(this.querySelector('svg'), {
                        y: 12 * direction,
                    })
                    tl.to(this.querySelector('svg'), {
                        y: 0,
                    })
                })
            })
        }
    }
}


